import { createReducer, combineReducers, PayloadAction } from "@reduxjs/toolkit";

import { IProjectsState } from "Model/State/IProjectsState";
import { generateUniqueId } from "Utils/UniqueId";
import { isFalse } from "Utils/Boolean";
import {
  uiSetActiveEditItemId,
  projectsSetTotalCount,
  projectsClear,
  projectsDeleteSuccess,
  projectsLastRequestOnSet,
  projectsLastRequestIdListSet,
  projectsRetrieveSuccess,
  projectsRetrieveSinceSuccess,
  projectsUpdateSuccess,
  projectsCloneSuccess,
  projectsCloneNext,
  projectsExportNext,
  projectsExportSuccess,
  projectsStagingMergeSuccess,
  projectsDeleteNext,
  projectsRetrieveExtendedSet,
  projectsSortSuccess,
  projectsFilterIdListSet
} from "../../Actions";
import { Filter } from "./Filter";
import { Sort } from "./Sort";
import { list } from "./List";

const hash = createReducer<string>(generateUniqueId(true), {
  [projectsCloneNext.type]: () => generateUniqueId(true),
  [projectsCloneSuccess.type]: () => generateUniqueId(true),
  [projectsDeleteNext.type]: () => generateUniqueId(true),
  [projectsDeleteSuccess.type]: () => generateUniqueId(true),
  [projectsExportNext.type]: () => generateUniqueId(true),
  [projectsExportSuccess.type]: () => generateUniqueId(true),
  [projectsFilterIdListSet.type]: () => generateUniqueId(true),
  [projectsRetrieveSinceSuccess.type]: () => generateUniqueId(true),
  [projectsRetrieveSuccess.type]: (state, { payload }: PayloadAction<boolean>) => (isFalse(payload, true) ? state : generateUniqueId(true)),
  [projectsSortSuccess.type]: () => generateUniqueId(true),
  [projectsStagingMergeSuccess.type]: () => generateUniqueId(true),
  [projectsUpdateSuccess.type]: () => generateUniqueId(true)
});

const totalCount = createReducer(0, {
  [projectsSetTotalCount.type]: (_, { payload: count }) => count,
  [projectsClear.type]: () => 0
});

const activeEditItemId = createReducer<string>(null, {
  [uiSetActiveEditItemId.type]: (_, { payload: id }) => id,
  [projectsClear.type]: () => null
});

const lastRequestOn = createReducer<string>(null, {
  [projectsLastRequestOnSet.type]: (_, { payload }) => payload,
  [projectsClear.type]: () => null
});

const lastRequestIdList = createReducer<string[]>([], {
  [projectsLastRequestIdListSet.type]: (_, { payload }) => payload,
  [projectsClear.type]: () => []
});

const isLoadingExtended = createReducer<boolean>(false, {
  [projectsRetrieveExtendedSet.type]: (_, { payload }) => payload
});

export const Projects = combineReducers<IProjectsState>({
  activeEditItemId,
  filter: Filter,
  hash,
  isLoadingExtended,
  lastRequestIdList,
  lastRequestOn,
  map: list,
  sort: Sort,
  totalCount
});
